export default "__VITE_ASSET__DNAAXSKV__"